import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css' // this must be commented out for deploy to production because it would overwrite the websites own bootstrap styles
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap'
import store from './model'

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(BootstrapVue)

new Vue({
  render: h => h(App),
  store
}).$mount('#app')
